<template>
  <TopGradientBlockLayout class="md:h-auto">
    <template #top>
      <MonthPicker v-if="layoutType === 'desktop'"
                   :date="currentMonth"
                   @change="$emit('changeMonth',$event)"/>
    </template>
    <div class="space-y-8">
      <template v-if="dateSelected">
        <div class="text-text text-xl font-bold
                  leading-tight capitalize">
          {{ formattedDateSelected }}
        </div>
        <template v-if="dateHasTransactions || dateHasPlannedTransactions">
          <CalendarInfoTransactions v-if="dateHasTransactions"/>
          <!--новый тип транзакций-->
          <CalendarInfoPlannedTransactions v-if="dateHasPlannedTransactions"
                                           :date-selected="dateSelected"/>
        </template>
      </template>
      <BaseButton v-if="!currentUserIsWatcher"
                  theme="red"
                  class="w-full"
                  @click="$emit('addTransaction')">
        {{ $t('planOperation') }}
      </BaseButton>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import {mapGetters} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import MonthPicker from "@/components/UI/MonthPicker";
import CalendarInfoTransactions from "@/components/cabinet/Money/Calendar/CalendarInfo/CalendarInfoTransactions";
import BaseButton from "@/components/UI/BaseButton";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";
import CalendarInfoPlannedTransactions
  from "@/components/cabinet/Money/Calendar/CalendarInfo/CalendarInfoPlannedTransactions";

export default {
  name: "CalendarInfo",
  components: {
    CalendarInfoPlannedTransactions,
    TransactionItem, BaseButton, CalendarInfoTransactions, MonthPicker, TopGradientBlockLayout
  },
  props: {
    currentMonth: {
      type: String
    },
    dateSelected: {
      type: [Number, String]
    }
  },
  computed: {
    ...mapGetters('theme', ['layoutType']),
    ...mapGetters('space/calendar', ['calendarData']),
    ...mapGetters('space', ['currentUserIsWatcher']),
    formattedDateSelected() {
      return this.$moment(this.dateSelected, 'YYYY-MM-DD').format('DD MMMM YYYY');
    },
    dateHasTransactions() {
      if (this.calendarData[this.dateSelected]) {
        const {expenses, incomes, transfers} = this.calendarData[this.dateSelected];
        return expenses || incomes || transfers;
      } else {
        return false;
      }
    },
    dateHasPlannedTransactions() {
      if (this.calendarData[this.dateSelected]) {
        const {incomes_planned, expenses_planned} = this.calendarData[this.dateSelected];
        return incomes_planned || expenses_planned;
      } else {
        return false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        emptyText: 'Select a day to see more information!',
        planOperation: 'Plan operation'
      },
      ru: {
        emptyText: 'Чтобы посмотреть больше информации, выберите день!',
        planOperation: 'Запланировать операцию'
      }
    },
  }
}
</script>